import{gql as e}from"@apollo/client";const t=e`
  query getAllTrackingOfStep($startDate: Date!, $endDate: Date!, $userFlowStepId: Int!, $questionIds: [Int]) {
    userFlowStepTrack {
      getAllTrackingOfStep(startDate: $startDate, endDate: $endDate, userFlowStepId: $userFlowStepId, questionIds: $questionIds) {
        instanceDate
        id
        answers {
          ... on QuestionAnswerMultilineTextType {
            text
          }
        }
      }
    }
  }
`;export{t as GET_ALL_TRACKING_OF_STEP_QUERY};
//# sourceMappingURL=useGetAllTrackingOfStep.graphql.js.map
